import styled from "styled-components";
import { ChangeEvent, ChoiceEmployee, IBlobFile, IFile, IUser, SupportTicket, TicketCommunication } from "../../../globals/interfaces";
import Attachments from "./Attachments";
import UploadAttachments from "./UploadAttachments";
import { Label } from "reactstrap";
import classnames from 'classnames';
import Comment from "./Comment";
import { Input } from "reactstrap";
import { useState } from "react";
import _ from "lodash";
import { formatDatetime } from "../../../utils";

interface Props {
    ticket: SupportTicket;
    attachments: Array<IBlobFile>;
    setAttachments: React.Dispatch<React.SetStateAction<Array<IBlobFile>>>;
    addAttachments: (files: Array<IFile>) => void;
    sendMessage: (message: string) => Promise<void>;
    user: IUser;
    userDetails: ChoiceEmployee | undefined;
}

export default function UpdateModalBody({
    ticket,
    attachments,
    setAttachments,
    addAttachments,
    sendMessage,
    user,
    userDetails
}: Props) {

    const {isDev} = user;
    const [message, setMessage] = useState('');

    const handleAddComment = async () => {
        await sendMessage(message);
        setMessage('');
    }


    return (
        <Container>
            <div>
                <Section>
                    <h4>APP SUPPORT  TICKET</h4>
                    <h6>User Details</h6>
                    <p>User: {userDetails.s_first_name} {userDetails.s_last_name}</p>
                    <p>Position: {userDetails.s_job_title}</p>
                    <p>Email: {userDetails.s_email}</p>
                    <p>Phone: {userDetails.s_phone_num}</p>
                </Section>
                <Section>
                    <h6>Ticket Progress</h6>
                    <p>Created: {formatDatetime(ticket.createdAt)}</p>
                    <p>Updated: {formatDatetime(ticket.modifiedAt)}</p>
                    <p>Current Status: {ticket.status}</p>
                    {/* <h6>Title: {ticket.unit}-{ticket.id}</h6>
                    <h6>Description: {ticket.description}</h6> */}
                    <Attachments
                        attachments={attachments}
                        setAttachments={setAttachments}
                        user={user}
                    />
                    <UploadAttachments addAttachments={addAttachments} />
                </Section>
            </div>
            <ChatSection>
                <h4>Chat</h4>
                <Label>Messages:</Label>
                <TicketCommunicationContainer>
                    {
                        _.get(ticket, 'ticketCommunication', []).map((item: TicketCommunication) => (
                            <div
                                className={classnames(
                                    'message',
                                    item.createdBy === user.s_email ? 'user' : 'other-user'
                                )}
                            >
                                <Comment item={item} isUser={item.createdBy === user.s_email} />
                            </div>
                        ))
                    }
                </TicketCommunicationContainer>
                <FlexContainer>
                    <ChatInput
                        type={'textarea'}
                        value={message}
                        onChange={(e: ChangeEvent) => setMessage(e.target.value)}
                        className={'normal-text'}
                    />
                    <SendMessageIcon
                        className={'fa-solid fa-paper-plane-top ml-2'}
                        onClick={handleAddComment}
                    />
                </FlexContainer>
            </ChatSection>
            {
                isDev && (
                    <Section>
                        <h4>Internal Notes</h4>
                    </Section>
                )
            }
        </Container>
    );
}

const Container = styled.div`
    display: flex;
    gap: 10px;
    /* height: 400px; */
`;

const Section = styled.div`
    border: 1px solid #d7d7d7;
    border-radius: 15px;
    flex: 1;
    padding: 10px;
    margin-bottom: 5px;

    & p {
        margin: 2px;
    }
`;

const ChatSection = styled(Section)`
    flex: 2;
`;

const ChatInput = styled(Input)`
    border-radius: 15px;
`;

const TicketCommunicationContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 260px;
    border: 1px solid #ccc;
    padding: 10px;
    overflow-y: auto;
    border-radius: 15px;

    .message {
        display: flex;
        margin: 5px 0;
        padding: 10px;
        border-radius: 10px;
        max-width: 80%;
    }
    .message.other-user {
        justify-content: flex-start;
        background-color: #e1ffc7;
    }
    .message.user {
        justify-content: flex-end;
        background-color: #cce5ff;
        align-self: flex-end;
    }
`;

const FlexContainer = styled.div`
    display: flex;
    align-items: center;
    margin-top: 2px;
    margin-bottom: 10px;
`;

const SendMessageIcon = styled.i`
    font-size: 24px;
    color: #5da81c;
`;

